

/*
 *
 * Date: 2025
 * Description: Preferences pages , can be used to change the theme or mode for now
 * Author: Philippe Leroux @SKITSC
 *
 */

//Modules
import { Box , IconButton } from "@mui/material"
import { ReactElement, useContext } from "react"
import { ThemeContext } from "../../context/context"
import { LightModeOutlined , DarkModeOutlined } from "@mui/icons-material";

//Utility && functions
import { setLocalKey } from "../../utils/utility"

const Preferences = ( ) : ReactElement => {
    const { setCurrentTheme , mode , primary } = useContext(ThemeContext)
    const handleMode = () => {
        mode === 'Light'? setCurrentTheme('Dark') : setCurrentTheme('Light')
        mode === 'Light'? setLocalKey('theme_mode','Dark' , 2592000000) : setLocalKey('theme_mode','Light' , 2592000000)
    } 
    const sizing = {
        width : '45px',
        height : '45px'
    }

    return (
        <Box>
            Preferences Page
            <Box>
                <IconButton sx={sizing} color='primary' onClick={ () => handleMode() }>
                    {mode === 'Dark' ? (
                        <DarkModeOutlined sx={{ color : primary}}/>
                    ) : (
                        <LightModeOutlined color="primary" />
                    )}
                </IconButton>
            </Box>
        </Box>
    )
}

export default Preferences